module.exports = __webpack_public_path__ + "static/img/Standard Logo_registry.31c7031.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/Standard Logo_registry.png
// module id = q83k
// module chunks = 1